import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { globalVar } from '../shared/global_variables';
import { WorkstockMultipleCCDCSuccessorsEntry } from './workstock-analysis/WorkstockMultipleSuccessorsEntry';
import { WorkstockAnalysisEntry } from './workstock-analysis/WorkstockAnalysisEntry';
import { WorkstockCountermeasuresEntry } from './workstock-countermeasures/WorkstockCountermeasuresEntry';
import { WorkstockSupplierAnalysisEntry } from './workstock-supplier-analysis/WorkstockSupplierAnalysisEntry';
import { WorkstockSupplierAnalysisBmwEntry } from './workstock-supplier-analysis-bmw/WorkstockSupplierAnalysisBmwEntry';
import { WorkstockSubCounters } from './WorkstockSubCounters';
import { WorkstockFavoriteAnalysisEntry } from './workstock-favorite-analysis/WorkstockFavoriteAnalysisEntry';

export const WORKSTOCK = '/workstock';
export const ANALYSIS = '/analysis';
export const COUNTERMEASURES = '/countermeasures';
export const SUPPLIER = '/supplier';
export const FAVORITES = '/favorites';

export const GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS = '/getWorkstockMultipleCCDCSuccessors';
export const GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS = '/getWorkstockIncompleteFullAnalysis';
export const GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS = '/getWorkstockIncompleteItoAnalysis';
export const GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED = '/getWorkstockAnalysisToBeConfirmed';
export const GET_TIME_CRITICAL_COUNTERMEASURES = '/getTimeCriticalCountermeasures';
export const GET_OPEN_COUNTERMEASURES = '/getOpenCountermeasures';
export const GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER = '/getSupplierAnalysisToBeHandedOver';
export const GET_SUPPLIER_ANALYSIS_HANDED_OVER = '/getSupplierAnalysisHandedOver';
export const GET_SUPPLIER_ANALYSIS_DECLINED = '/getSupplierAnalysisDeclined';
export const GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW = '/getSupplierAnalysisToBeConfirmedBmw';
export const GET_SUPPLIER_ANALYSIS_DECLINED_BMW = '/getSupplierAnalysisDeclinedBmw';
export const CONFIRM_OR_SET_CCDC_SUCCESSORS = '/setCCDCSuccessors';
export const GET_WORKSTOCK_SUB_COUNTERS = '/getUserWorkstockSubCounters';
export const GET_WORKSTOCK_FAVORITE_ANALYSIS = '/getWorkstockFavoriteAnalysis';
export const REMOVE_FAVORITE = '/removeFavorite';

@Injectable({
    providedIn: 'root'
})
export class WorkstockService {
    constructor(private http: HttpClient) {}

    public getWorkstockMultipleCCDCSuccessors(): Observable<WorkstockMultipleCCDCSuccessorsEntry[]> {
        return this.http.get<WorkstockMultipleCCDCSuccessorsEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + ANALYSIS + GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS
        );
    }

    public getWorkstockIncompleteFullAnalysis(): Observable<WorkstockAnalysisEntry[]> {
        return this.http.get<WorkstockAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + ANALYSIS + GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS
        );
    }

    public getWorkstockIncompleteItoAnalysis(): Observable<WorkstockAnalysisEntry[]> {
        return this.http.get<WorkstockAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + ANALYSIS + GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS
        );
    }

    public getWorkstockAnalysisToBeConfirmed(): Observable<WorkstockAnalysisEntry[]> {
        return this.http.get<WorkstockAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + ANALYSIS + GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED
        );
    }

    public getWorkstockTimeCriticalCountermeasures(): Observable<WorkstockCountermeasuresEntry[]> {
        return this.http.get<WorkstockCountermeasuresEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + COUNTERMEASURES + GET_TIME_CRITICAL_COUNTERMEASURES
        );
    }

    public getWorkstockOpenCountermeasures(): Observable<WorkstockCountermeasuresEntry[]> {
        return this.http.get<WorkstockCountermeasuresEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + COUNTERMEASURES + GET_OPEN_COUNTERMEASURES
        );
    }

    public getWorkstockSupplierAnalysisToBeHandedOver(): Observable<WorkstockSupplierAnalysisEntry[]> {
        return this.http.get<WorkstockSupplierAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + SUPPLIER + GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER
        );
    }

    public getWorkstockSupplierAnalysisHandedOver(): Observable<WorkstockSupplierAnalysisEntry[]> {
        return this.http.get<WorkstockSupplierAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + SUPPLIER + GET_SUPPLIER_ANALYSIS_HANDED_OVER
        );
    }

    public getWorkstockSupplierAnalysisDeclined(): Observable<WorkstockSupplierAnalysisEntry[]> {
        return this.http.get<WorkstockSupplierAnalysisEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + SUPPLIER + GET_SUPPLIER_ANALYSIS_DECLINED
        );
    }

    public getWorkstockSupplierAnalysisToBeConfirmedBmw(): Observable<WorkstockSupplierAnalysisBmwEntry[]> {
        return this.http.get<WorkstockSupplierAnalysisBmwEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + SUPPLIER + GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW
        );
    }

    public getWorkstockSupplierAnalysisDeclinedBmw(): Observable<WorkstockSupplierAnalysisBmwEntry[]> {
        return this.http.get<WorkstockSupplierAnalysisBmwEntry[]>(
            environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + SUPPLIER + GET_SUPPLIER_ANALYSIS_DECLINED_BMW
        );
    }

    public confirmOrSetCCDCSuccessors(workstockAnalysis: WorkstockMultipleCCDCSuccessorsEntry): Observable<number> {
        let params = {
            analysisId: workstockAnalysis.id,
            selectedCCDCSuccessors: workstockAnalysis.selectedCCDCSuccessors
        };
        return this.http.post<number>(environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + ANALYSIS + CONFIRM_OR_SET_CCDC_SUCCESSORS, params);
    }

    public getWorkstockSubCounters(): Observable<WorkstockSubCounters> {
        return this.http.get<WorkstockSubCounters>(environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + GET_WORKSTOCK_SUB_COUNTERS);
    }

    public getWorkstockFavoriteAnalysis(): Observable<WorkstockFavoriteAnalysisEntry[]> {
        return this.http.get<WorkstockFavoriteAnalysisEntry[]>(environment.baseUrl + globalVar.requestPrefix + FAVORITES + GET_WORKSTOCK_FAVORITE_ANALYSIS);
    }

    public removeFavoriteAnalysis(analysisKey: string): Observable<Response> {
        return this.http.delete<Response>(environment.baseUrl + globalVar.requestPrefix + FAVORITES + REMOVE_FAVORITE + '/' + analysisKey);
    }
}
